/** Тип объекта, к которому относится уведомление. Значения синхронизированы с backend enum. */
export enum NotificationTargetObjectType {
    Process = 0,
    Activity = 1,
    Document = 2,
    Another = 3,
}

/** Уведомление */
export interface INotification {
    /** Уникальный ID */
    id: string;
    /** Тема */
    subject: string;
    /** Сообщение */
    text: string;
    /** дата отправки */
    sendedAt: Date;
    /** Прочитано */
    read: boolean;
    /** Ключ целевого объекта */
    targetObjectKey?: string | null;
    /** Тип целевого объекта */
    targetObjectType?: NotificationTargetObjectType | null;
    /**
     * Тег типа уведомления вида `<домен>.<объект>.<действие>` (напр. `assignment.approver.self`,
     * `duetime.activity.elapsed`) либо `reminder` для напоминаний. Сворачивается в UI-категорию
     * функцией `categoryFromTag` (см. `@utils/notificationCategory`). Может отсутствовать у
     * легаси-уведомлений — тогда категория не показывается.
     */
    tag?: string | null;
}
